import api from 'skin/http';

//Запрос на отправку смс
function check(phone, signal) {
	return new Promise((resolve, reject) => {
		const opt = {
			signal,
			method: 'GET',
			url: 'api/other/signup/phone/check',
			params: {
				val: phone
			},
			headers: {
				nowait: true
			}
		}
		api(opt)
		.then(r => {
			if (r.code === 'ERR_CANCELED') return resolve();
			if (r.data.error) return reject(r.data.error);
			resolve('На указаный номер отправлено СМС с кодом');
		})
		.catch(reject)
	})
}

export default check